<script>
import * as API from '../api/post-shared';

export default {
  components: {
    CpButton: require('../button').default,
    CpButtonLink: require('../button-link').default,
    CpDialog: require('../dialog').default,
    CpBoxContent: require('../box-content').default,
    CpBox: require('../box').default,
    CpTextInput: require('../inputs/text').default,
    CpSocialFeedCustomContent: require('../social-feed/posts/CustomContent').default,
    CpSocialFeedBlogPost: require('../social-feed/posts/blog-post').default,
    CpSocialFeedNewsPost: require('../social-feed/posts/news-post').default,
    CpSocialFeedVideoPost: require('../social-feed/posts/video-post').default,
    CpSocialFeedPetitionPost: require('../social-feed/posts/petition-post').default,
    CpSocialFeedRacePost: require('../social-feed/posts/race-post').default,
    CpSocialFeedCandidatePost: require('../social-feed/posts/candidate-post').default,
    CpSocialFeedLobbyPost: require('../social-feed/posts/lobby-post').default,
    CpSearchResult: require('../explore-campaigns/result').default, //Campaigns
    CpOpinionsItem: require('../opinions/opinions-item').default,
    CpSocialFeedPollPost: require('../social-feed/posts/poll-post').default,
    CpEventCard: require('../events/event-card.vue').default,
    CpGroup: require('../groups/group-card').default,
    CpSocialFeedLivestreamPost: require('../social-feed/posts/livestream-post').default,
    CpLawmakerPage: require('../lawmaker/LawmakerPage').default,
    CpDialogAuthForm: require('../auth-form/dialog-auth-form').default,
  },
  props: {
    handleDialog: Function,
    showDialog: Boolean,
    post: Object,
    type: String,
    resultsUrlSuffix: [String, Boolean],
    modalFeed: { type: Boolean, default: false },
  },
  name: 'CpSharePost',
  methods: {
    sharePost() {
      if (!this.authUser && !this.modalFeed) {
        this.showAuthModal = true;
      } else {
        this.handleSharePost();
      }
    },
    handleSharePost() {
      this.loading = true;
      let id;
      switch (this.type) {
        case 'crowdpac':
          id = parseInt(this.post.objectID.match(/(\d+)/g)[0]);
          break;
        default:
          id = this.post.id;
          break;
      }

      API.createPostShared(id, this.type, { comment: this.comment, modalFeed: this.modalFeed })
        .then(response => {
          this.loading = false;
          if (!this.authUser && this.modalFeed) {
            this.$emit('postButtonClicked', response.post_shared.id);
          } else {
            this.shareSuccess = true;
          }
        })
        .catch(error => {
          this.loading = false;
          this.shareError = true;
          console.warn(error);
        });
    },
    handleCloseButton() {
      this.showAuthModal = false;
    },
  },
  data() {
    return {
      comment: '',
      loading: false,
      shareSuccess: false,
      shareError: false,
      showAuthModal: false,
    };
  },
  computed: {
    authUser() {
      return this.$root.authUser;
    },
  },
};
</script>
<template>
  <div>
  <cp-dialog v-if="showDialog">
    <cp-box>
      <cp-box-content>
        <section class="box-share-post">
          <svg
            @click.prevent="handleDialog"
            class="close-svg-icon"
            stroke="currentColor"
            fill="currentColor"
            stroke-width="0"
            viewBox="0 0 512 512"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M278.6 256l68.2-68.2c6.2-6.2 6.2-16.4 0-22.6-6.2-6.2-16.4-6.2-22.6 0L256 233.4l-68.2-68.2c-6.2-6.2-16.4-6.2-22.6 0-3.1 3.1-4.7 7.2-4.7 11.3 0 4.1 1.6 8.2 4.7 11.3l68.2 68.2-68.2 68.2c-3.1 3.1-4.7 7.2-4.7 11.3 0 4.1 1.6 8.2 4.7 11.3 6.2 6.2 16.4 6.2 22.6 0l68.2-68.2 68.2 68.2c6.2 6.2 16.4 6.2 22.6 0 6.2-6.2 6.2-16.4 0-22.6L278.6 256z"
            ></path>
          </svg>
          <template v-if="!shareSuccess && !shareError" class="share-container">
            <cp-text-input v-model="comment" placeholder="Add a comment!" style="width: 100%; margin-bottom: 10px" class="comment-input"></cp-text-input>

            <CpSocialFeedCustomContent v-if="type == 'custom-contents'" :key="post.id" :post="post" :for-share="true" />
            <cp-social-feed-blog-post v-if="type == 'blogs'" :key="post.id" :blog="post" :for-share="true" />
            <cp-social-feed-petition-post v-if="type == 'petitions'" :key="post.id" :petition="post" :for-share="true" />
            <cp-social-feed-news-post v-if="type == 'news'" :key="post.rss_article_url" :news="post" :for-share="true" />
            <cp-search-result v-if="type == 'crowdpac'" :result="post" :for-share="true" :results-url-suffix="resultsUrlSuffix"></cp-search-result>
            <cp-social-feed-race-post v-if="type == 'elections'" :key="post.id" :race="post" :for-share="true" />
            <cp-opinions-item v-if="['opinion', 'group-opinions'].includes(type)" :data="post" :for-share="true" :modal-share="true" :type="type" :explore="true" />
            <cp-group v-if="type == 'groups'" :group="post" :for-share="true" :modal-share="true" :explore="true" />
            <cp-social-feed-candidate-post v-if="type == 'candidate'" :candidate="post" :for-share="true" />
            <cp-social-feed-lobby-post v-if="type == 'lobby'" :lobby="post" :for-share="true" />
            <cp-social-feed-poll-post v-if="type == 'polls'" :poll="post" :for-share="true" />
            <div v-if="type == 'events'">
              <cp-social-feed-livestream-post
                v-if="post.archive_url && post.status == 'shared'"
                :data="post"
                :playback="post.archive_url"
                :title="post.title"
                :type="'event'"
                :for-share="true"
              />
              <cp-event-card v-else :event="post" :for-share="true" :action-buttons-disabled="true" />
            </div>
            <cp-social-feed-livestream-post
              v-if="type === 'livestreams'"
              :data="post"
              :playback="post.archive_url"
              :title="post.title"
              :type="post.type"
              :for-share="true"
            />
            <CpLawmakerPage v-if="type == 'officials'" :key="post.id" :post="post" :for-share="true" />

            <cp-button primary block style="padding: 7px; margin-top: 5px" @click="sharePost" class="btn-share" :loading="loading" :disabled="loading"
              >Share Post</cp-button
            >
          </template>
          <template v-if="shareSuccess">
            <div style="display: flex; justify-content: center">
              <i class="fas fa-check share-icon"></i>
            </div>
            <p class="heading-4 neutral6color boldText">Post shared successfully!</p>
          </template>
          <template v-if="shareError">
            <div style="display: flex; justify-content: center">
              <i class="fas fa-times error-icon"></i>
            </div>
            <p class="heading-4 neutral6color boldText" style="text-align: center">An error has occurred!</p>
          </template>
        </section>
      </cp-box-content>
    </cp-box>
  </cp-dialog>
  <cp-dialog-auth-form v-if="showAuthModal" :handleCloseButton="handleCloseButton" showSignUp :callback-action="handleSharePost" />
</div>
</template>
<style>
.box-share-post {
  margin: 3em 2.5em;
  max-width: 55ch;
}
.btn-share span.button__content {
  padding: 0;
}
.comment-input div input.text-input:focus {
  outline: none !important;
}
.comment-input div input.text-input {
  background: transparent;
  border: 0;
  color: black;
  flex-grow: 1;
  font: inherit;
  width: auto;
  padding: 0.5em;
  margin-bottom: 0;
}
.share-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  max-width: 1000px;
  margin: auto;
}
.share-icon {
  font-size: 3em;
  color: var(--success);
}
.error-icon {
  font-size: 3em;
  color: red;
}
div.icon-wrapper {
  width: 100%;
  height: 100%;
  flex-direction: row;
  align-content: center;
  align-items: center;
  background-image: none !important;
  margin-top: 0px;
}
svg.share-svg-icon {
  height: 1em;
  width: 1em;
}
div.network-text-title {
  font-size: 10px;
  font-weight: 700;
  padding-bottom: 5px;
}
svg.close-svg-icon {
  float: right;
  top: 5px;
  right: 5px;
  position: absolute;
  height: 2.5em;
  width: 2.5em;
  cursor: pointer;
}
div.feed svg {
  color: #555555 !important;
  height: 1.5em !important;
  width: 1.5em !important;
}
.boldText {
  font-weight: bold;
}
.neutral6color {
  color: #404040;
}
@media only screen and (max-width: 767px) {
  .box-share-post {
    margin: 0;
  }
}
</style>
